export enum DashboardSection {
  RecentRecipes = 'recentRecipes',
  SharedWithMe = 'sharedWithMe',
  WorkspaceFiles = 'workspaceFiles',
  SharedApps = 'sharedApps',
  Toolkit = 'toolkit',
  Archive = 'archive',
}

/** The one section with its own address. It is open whenever the path is this, and is never stored. */
export const TOOLKIT_PATH = '/explore';
